import api from "./api";

const debitNoteService = {
  getAll: async (params = {}) => {
    const response = await api.get("/debit-notes", { params });
    return response.data;
  },
  getById: async (id) => {
    const response = await api.get(`/debit-notes/${id}`);
    return response.data;
  },
  create: async (data) => {
    const response = await api.post("/debit-notes", data);
    return response.data;
  },
  cancel: async (id) => {
    const response = await api.delete(`/debit-notes/${id}`);
    return response.data;
  },
  getStats: async (params = {}) => {
    const response = await api.get("/debit-notes/stats", { params });
    return response.data;
  },
  downloadPdf: async (id, numeroControl) => {
    const response = await api.get(`/debit-notes/${id}/pdf`, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `ND_${numeroControl}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },
  downloadJson: async (id, numeroControl) => {
    const response = await api.get(`/debit-notes/${id}/json`, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `ND_${numeroControl}.json`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },
  downloadJsonFirmado: async (id, numeroControl) => {
    const response = await api.get(`/debit-notes/${id}/json-firmado`, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `ND_${numeroControl}_firmado.json`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },
  getJsonContent: async (id) => {
    const response = await api.get(`/debit-notes/${id}/json-content`);
    return response.data;
  },
};

export default debitNoteService;